import { Component, OnInit } from '@angular/core';
import { NzModalRef } from 'ng-zorro-antd/modal';
import { InfiniteResult } from 'src/app/_models/body';
import { StageService } from 'src/app/_services/stage.service';

@Component({
  selector: 'app-stage-groups-dialog',
  templateUrl: './stage-groups-dialog.component.html',
  styleUrls: ['./stage-groups-dialog.component.css']
})
export class StageGroupsDialogComponent implements OnInit {
  stageGroups: any[] = [];
  loading = false;
  searchName = '';
  searchId = '';

  constructor(
    private stageService: StageService,
    private modalRef: NzModalRef
  ) {}

  ngOnInit(): void {}

  getStageGroup(params: any): void {
    this.loading = true;
    this.stageService.getStageGroup(params).subscribe(res => {
      this.stageGroups = res.data || [];
      this.loading = false;
    }, () => {
      this.loading = false;
    });
  }

  onSearch(): void {
    const params: any = { PageSize: '-1' };
    if (this.searchId.trim()) {
      params.Id = this.searchId.trim();
    }
    if (this.searchName.trim()) {
      params.Name = this.searchName.trim();
    }
    this.getStageGroup(params);
  }

  showGroupDetail(data): void {
    this.stageService.getStagesForKeyInfo({ GroupId: data.id, PageSize: '-1' }).subscribe((res: InfiniteResult) => {
      const stages = res.data;
      this.modalRef.close({ ...data, stages: stages });
    });
  }

  trackById(index: number, item: any): string {
    return item.id;
  }
}

